export const REQUEST_EDIT_STATUS_MODAL_QA_NAME_SUBMIT_BTN = 'Change'

export const REQUEST_EDIT_STATUS_MODAL_QA_NAME = 'ChangeStatus'

export const REQUEST_EDIT_STATUS_FIELD_NAME = 'status'

export const REQUEST_EDIT_STATUS_DEFAULT_VALUE = 1 // Warning! It's not stable cause this is hardcode of item's id
